var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{
		'small': _vm.small,
		'medium': _vm.medium,
		'large': _vm.large,
		'extra-large': _vm.extraLarge,
	},attrs:{"width":_vm.size,"height":_vm.size,"fill":_vm.color,"viewBox":_vm.getViewBox}},[_c('path',{attrs:{"d":_vm.getPathD}})])}
var staticRenderFns = []

export { render, staticRenderFns }